var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutgoingCall24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outgoing_Call_24px",
    "data-name": "Outgoing Call_24px",
    transform: "translate(-228 -20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1031",
    "data-name": "Rectangle 1031",
    width: 24,
    height: 24,
    transform: "translate(228 20)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "phone-outgoing",
    transform: "translate(227.444 20.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M23,7V1H17",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_143",
    "data-name": "Line 143",
    y1: 7,
    x2: 7,
    transform: "translate(16 1)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M22,16.92v3a2,2,0,0,1-2.18,2,19.79,19.79,0,0,1-8.63-3.07,19.5,19.5,0,0,1-6-6A19.79,19.79,0,0,1,2.12,4.18,2,2,0,0,1,4.11,2h3a2,2,0,0,1,2,1.72,12.84,12.84,0,0,0,.7,2.81,2,2,0,0,1-.45,2.11L8.09,9.91a16,16,0,0,0,6,6l1.27-1.27a2,2,0,0,1,2.11-.45,12.84,12.84,0,0,0,2.81.7A2,2,0,0,1,22,16.92Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoingCall24Px);
export default __webpack_public_path__ + "static/media/outgoing Call_24px.c344f825f0ad5d06c97fe08d6e3f1aa1.svg";
export { ForwardRef as ReactComponent };